// Core imports
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';

// Components imports
import { Button, Popover } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';

const ReadMorePopover = ({ message, searchFilter, buttonClassName }) => {
  return (
    <Popover
      onClick={(e) => e.stopPropagation()}
      content={
        <Highlighter
          onClick={(e) => e.stopPropagation()}
          highlightClassName="bg-highlight p-0"
          searchWords={[searchFilter]}
          autoEscape
          textToHighlight={(message)}
        />
      }
      overlayInnerStyle={{ maxWidth: 250, maxHeight: 360, overflowY: 'auto' }}
      trigger="click"
    >
      <Button
        size="small"
        type="text"
        className={`bg-layout-gray border-radius-base ${buttonClassName}`}
        icon={<EllipsisOutlined />}
      />
    </Popover>
  );
};

ReadMorePopover.propTypes = {
  message: PropTypes.string,
  searchFilter: PropTypes.string,
  buttonClassName: PropTypes.string
};

export default ReadMorePopover;
